import { render, staticRenderFns } from "./headerAd.vue?vue&type=template&id=0cfc642a&scoped=true&"
import script from "./headerAd.vue?vue&type=script&lang=js&"
export * from "./headerAd.vue?vue&type=script&lang=js&"
import style0 from "./headerAd.vue?vue&type=style&index=0&id=0cfc642a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc642a",
  null
  
)

export default component.exports